import React from 'react';
import DeliveryAndPaymentsListFunctional from './components/delivery-and-payments-list-functional';
import './delivery-and-payments.scss';

const DeliveryAndPaymentsList = () => {
	return <DeliveryAndPaymentsListFunctional />;
};

export default DeliveryAndPaymentsList;
